import { FunctionComponent, useEffect, useState } from 'react';
import { BarChart as RechartsBarChart, Bar, XAxis, ResponsiveContainer } from 'recharts';
import { IBarChart, IBarChartData, ILabelProps } from '../Models/BarChartModel';
import './BarChart.scss';
const COLORS = [
  '#FFEAA9',
  '#C9F3F4',
  '#E6E6E6',
  '#FFDB50',
  '#99E5EA',
  '#C0BFC0',
  '#FFD000',
  '#78E1E1',
  '#F5F5F5',
  '#28A3AF',
  '#1A1446',
];
const renderCustomBarLabel = (labelProps: ILabelProps) => {
  const fontSize = 18;
  const y = labelProps.height > fontSize * 3 ? labelProps.y + 12 + fontSize : labelProps.y;
  return (
    <text x={labelProps.x + labelProps.width / 2} y={y} dy={-2} fill="#666" fontSize={fontSize} textAnchor="middle">
      {labelProps.value}
    </text>
  );
};

const BarChart: FunctionComponent<any> = (props: IBarChart) => {
  const [barChartData, setBarChartData] = useState<IBarChartData[]>(props.barChartInput);

  useEffect(() => {
    if (props.barChartInput) {
      let newChartData = props.barChartInput.map((cd, index) => {
        return { ...cd, fill: COLORS[index % COLORS.length] };
      });
      setBarChartData(newChartData);
    }
  }, [props.barChartInput]);

  return (
    <>
      {props.chartTitle && (
        <p style={{ fontSize: 16, fontWeight: 400, paddingBottom: 10, textAlign: 'center' }}>{props.chartTitle}</p>
      )}
      <ResponsiveContainer width="100%" height="100%" minHeight="200px">
        <RechartsBarChart
          data={barChartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <XAxis dataKey="name" tickLine={false} axisLine={false} style={{ fontWeight: 700, fontSize: '12px' }} />
          <Bar dataKey="value" label={renderCustomBarLabel} />
        </RechartsBarChart>
      </ResponsiveContainer>
    </>
  );
};

export default BarChart;
